import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { InventoryItemCreateFormGroup } from './inventory-item-create-form-group.interface';
import { InventoryItemStatuses } from '../../enums/inventory-item-statuses.enum';
import { InventoryItemType } from '../../enums/inventory-item-type.enum';

@Injectable()
export class InventoryItemCreateFormModel {
  public readonly fieldNames = {
    number: 'number',
    displayName: 'displayName',
    displayName2: 'displayName2',
    goodsCategoryId: 'goodsCategoryId',
    gtin: 'gtin',
    itemType: 'itemType',
    status: 'status',
    manufacturer: 'manufacturer',
    model: 'model',
    baseUnitOfMeasureId: 'baseUnitOfMeasureId',
    unitPrice: 'unitPrice',
    unitCost: 'unitCost',
    currencyCode: 'currencyCode',
    priceIncludesTax: 'priceIncludesTax',
  };

  public form: FormGroup<InventoryItemCreateFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<InventoryItemCreateFormGroup>({
      number: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(32)],
      }),
      displayName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(128)],
      }),
      displayName2: new FormControl(null, [Validators.maxLength(256)]),
      goodsCategoryId: new FormControl(null),
      gtin: new FormControl(null, [Validators.maxLength(64)]),
      itemType: new FormControl<InventoryItemType>('Product', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      status: new FormControl(InventoryItemStatuses.Active, {
        nonNullable: true,
      }),
      manufacturer: new FormControl(null, [Validators.maxLength(128)]),
      model: new FormControl(null, [Validators.maxLength(128)]),
      baseUnitOfMeasureId: new FormControl<number | null>(null, {
        validators: [Validators.required],
      }),
      unitPrice: new FormControl(0, {
        nonNullable: true,
        validators: [Validators.min(0)],
      }),
      unitCost: new FormControl(0, {
        nonNullable: true,
        validators: [Validators.min(0)],
      }),
      currencyCode: new FormControl('EUR', [Validators.maxLength(16)]),
      priceIncludesTax: new FormControl(true, {
        nonNullable: true,
      }),
    });
  }
}
